import React from 'react';

const InfoCard = ({ card }) => {
    const { name, time, icon, bgClass, des } = card;
    return (
        <div className={`card text-white p-6 md:card-side shadow-xl ${bgClass}`}>
            <figure>
                <img src={icon} alt="Movie" />
            </figure>
            <div className="card-body">
                <h2 className="card-title">{name}</h2>
                <p>{time}</p>
                <p>{des}</p>
            </div>
        </div>
    );
};

export default InfoCard;